import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';

class CompanyWorkingModal extends Component{
  constructor(props) {
    super(props);
    let {company} = this.props;

    this.state = {
      name: (company && company.get('name')) || "",
      ownerName: (company && company.get('ownerName')) || "",
      contact: (company && company.get('contact')) || "",
      address: (company && company.get('address')) || ""
    }
  }

  handleChange = (e) => {
    let {name, value} = e.target

    this.setState({[name]: value})
  }

  handleAction = () => {
    let {name, ownerName, contact, address} = this.state;

    this.props.action(name, ownerName, contact, address);
  }

  render() {
    let {dismiss, mode} = this.props;

    return (
      <Modal.Dialog className="setting-working-modal">
        <Modal.Header>
          <Modal.Title>
            修改資料
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form-horizontal">
            <div className="form-group" >
              <label className="col-sm-2 control-label">名稱</label>
              <div className="col-sm-10">
                <input                    
                  type="text"
                  name="name"
                  value={this.state.name}
                  onChange={this.handleChange}
                  className="form-control"/>
              </div>
            </div>

            <div className="form-group" >
              <label className="col-sm-2 control-label">業主姓名</label>
              <div className="col-sm-10">
                <input                    
                  type="text"
                  name="ownerName"
                  value={this.state.ownerName}
                  onChange={this.handleChange}
                  className="form-control"/>
              </div>
            </div>

            <div className="form-group" >
              <label className="col-sm-2 control-label">聯絡資料</label>
              <div className="col-sm-10">
                <input                    
                  type="text"
                  name="contact"
                  value={this.state.contact}
                  onChange={this.handleChange}
                  className="form-control"/>
              </div>
            </div>

            <div className="form-group" >
              <label className="col-sm-2 control-label">辦公地址</label>
              <div className="col-sm-10">
                <input                    
                  type="text"
                  name="address"
                  value={this.state.address}
                  onChange={this.handleChange}
                  className="form-control"/>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button 
            className="btn btn-primary"
            onClick={this.handleAction}>
            {(mode === 'EDIT'? "修改": "新增")}
          </button>
          <button
            className="btn btn-default"
            onClick={dismiss}>
            關閉
          </button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}


export default CompanyWorkingModal;



// WEBPACK FOOTER //
// ./src/components/Setting/CompanyWorkingModal.js